import React from 'react';
import { Card, Button, Tag, Avatar } from "antd";
import {
    EditOutlined,
    DeleteOutlined,
    CopyOutlined,
    FileTextOutlined
} from "@ant-design/icons";
import { cn } from "../../../../utils/cn";

const EnhancedAutorespondersGridView = ({
    record,
    actions = [],
    onCardClick = () => { }
}) => {
    // Filter actions based on conditions
    const filteredActions = actions
        .map((action) => {
            if (action.condition && !action.condition(record)) {
                return null;
            }
            return action;
        })
        .filter(Boolean);

    const getAvatarContent = () => {
        return <FileTextOutlined />;
    };

    return (
        <Card
            hoverable
            className="h-full cursor-pointer"
            onClick={onCardClick}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                            icon={getAvatarContent()}
                        />
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate text-primary">
                                {record.name || "N/A"}
                            </h3>
                            <Tag color="cyan">Autoresponder</Tag>
                        </div>
                    </div>
                </div>

                {/* Info */}
                <div className="space-y-2 border-b border-gray-200 pb-3">
                    <div className="flex items-center text-sm text-gray-600">
                        <span className="truncate font-semibold">
                            Title: <span className="text-gray-800">{record.title || "No Title"}</span>
                        </span>
                    </div>
                </div>

                {/* Message Preview */}
                <div className="space-y-1">
                    <span className="text-xs text-gray-400 font-medium uppercase tracking-wider">Message Preview</span>
                    <div
                        className="text-sm text-gray-600 line-clamp-2"
                        dangerouslySetInnerHTML={{ __html: record.message }}
                    />
                </div>

                {/* Action Buttons */}
                {filteredActions.length > 0 && (
                    <div
                        className={cn(
                            "grid gap-2 pt-3 border-t border-gray-200",
                            filteredActions.length === 1 ? "grid-cols-1" :
                                filteredActions.length === 2 ? "grid-cols-2" : "grid-cols-3"
                        )}
                    >
                        {filteredActions.map((action, idx) => (
                            <Button
                                key={idx}
                                title={action.title ?? action.label}
                                className={cn(
                                    "text-sm font-medium h-9 my-1 !border-primary !text-primary hover:!bg-primary hover:!text-white !min-w-full flex justify-center items-center transition-colors duration-150 ease-in-out",
                                    action.className
                                    // Custom styling for specific labels to match list actions
                                    // (already passed in action.className from list)
                                )}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    action.onClick(record);
                                }}
                            >
                                {action.icon &&
                                    React.cloneElement(action.icon, { className: "mr-2" })}
                                {action.label}
                            </Button>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    );
};

export default EnhancedAutorespondersGridView;
